interface MatchResultCardProps {
  matchday: number
  homeName: string
  awayName: string
  homeScore: number
  awayScore: number
  won: boolean
  isHome: boolean
}

// Compact TV-strip row for a played fixture.
export function MatchResultCard({ matchday, homeName, awayName, homeScore, awayScore, won, isHome }: MatchResultCardProps) {
  return (
    <div className={`match-result-card ${won ? 'won' : 'lost'}`}>
      <span className="chip-angled">J{matchday}</span>
      <span className={`match-result-name${isHome ? ' me' : ''}`}>{homeName}</span>
      <span className="match-result-score">
        {homeScore} – {awayScore}
      </span>
      <span className={`match-result-name away${!isHome ? ' me' : ''}`}>{awayName}</span>
    </div>
  )
}
